export default __webpack_public_path__ + "static/media/1880.12f322fb.jpg";